// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".associated_customer[data-v-62b7e4ac] {\n  /*height: 50vh;*/\n}\n", ""]);
// Exports
module.exports = exports;
